export default __webpack_public_path__ + "static/media/prensesselin9.7b95af01.jpg";